import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../helpers/AuthContext";

function ProtectedRoute() {
  const { authState, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return <div>Chargement...</div>;
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
/* import React, { useContext, useEffect } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom'; // Utilisez Navigate pour la redirection
import { AuthContext } from './AuthContext'; // Assurez-vous du chemin correct pour le contexte

const ProtectedRoute = () => {
  const { authState, setRedirectToLogin } = useContext(AuthContext);
  const navigate = useNavigate();

  if (!authState.isAuthenticated) {
    //setRedirectToLogin(window.location.pathname); // Enregistrer l'URL d'origine
    navigate('/login');
  }

  return <Outlet />;
};

export default ProtectedRoute; */

